var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-2 py-1"},[_c('agent-list',{attrs:{"hide-title":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }